import { Extension } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";
import type { Node } from "@tiptap/pm/model";

const MERGE_TAG_PATTERN = /\{\{\s*[a-z0-9_.]+\s*\}\}/gi;

const MERGE_TAG_CLASS =
  "rounded bg-indigo-50 px-1 py-0.5 font-mono text-[0.85em] text-indigo-700 ring-1 ring-indigo-200";

/**
 * Decorations rather than a node type — the tag stays plain text, so the body
 * the backend resolves is the same string the editor started with.
 */
function mergeTagDecorations(doc: Node): DecorationSet {
  const decorations: Decoration[] = [];

  doc.descendants((node, pos) => {
    if (!node.isText || !node.text) {
      return;
    }

    for (const match of node.text.matchAll(MERGE_TAG_PATTERN)) {
      const from = pos + match.index;

      decorations.push(
        Decoration.inline(from, from + match[0].length, {
          class: MERGE_TAG_CLASS,
        }),
      );
    }
  });

  return DecorationSet.create(doc, decorations);
}

export const MergeTagHighlight = Extension.create({
  name: "mergeTagHighlight",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("mergeTagHighlight"),
        props: {
          decorations: (state) => mergeTagDecorations(state.doc),
        },
      }),
    ];
  },
});
